export const homeKeys = {
  all: ["home"] as const,
  overview: () => [...homeKeys.all, "overview"] as const,
}
